var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddquestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 1.58333C15.9964 1.58333 17.4167 3.00358 17.4167 4.75V14.25C17.4167 15.9964 15.9964 17.4167 14.25 17.4167H4.75C3.00358 17.4167 1.58333 15.9964 1.58333 14.25V4.75C1.58333 3.00358 3.00358 1.58333 4.75 1.58333H14.25ZM14.25 0H4.75C2.12642 0 0 2.12642 0 4.75V14.25C0 16.8736 2.12642 19 4.75 19H14.25C16.8736 19 19 16.8736 19 14.25V4.75C19 2.12642 16.8736 0 14.25 0Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50016 14.25C9.06316 14.25 8.7085 13.8961 8.7085 13.4583V5.54167C8.7085 5.10467 9.06316 4.75 9.50016 4.75C9.93716 4.75 10.2918 5.10467 10.2918 5.54167V13.4583C10.2918 13.8961 9.93716 14.25 9.50016 14.25Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 9.49998C4.75 9.06298 5.10388 8.70831 5.54167 8.70831H13.4583C13.8953 8.70831 14.25 9.06298 14.25 9.49998C14.25 9.93698 13.8953 10.2916 13.4583 10.2916H5.54167C5.10388 10.2916 4.75 9.93698 4.75 9.49998Z",
    fill: "#B8B8B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddquestion);
export default __webpack_public_path__ + "static/media/addquestion.02699668118d15e45ba833d2db47db73.svg";
export { ForwardRef as ReactComponent };